/**
 * BackendAgentMessageTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {AgentInput} from "./AgentInput";
import {AgentOutput} from "./AgentOutput";
import {BackendAgentMessageCollection} from "./BackendAgentMessageCollection";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendAgentMessageTag extends TagAbstract {
    /**
     * Returns a paginated list of agent messages
     *
     * @returns {Promise<BackendAgentMessageCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(agentId: string, chatId?: string): Promise<BackendAgentMessageCollection> {
        const url = this.parser.url('/backend/agent/$agent_id<[0-9]+|^~>/message', {
            'agent_id': agentId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'chat_id': chatId,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendAgentMessageCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Submits a new agent message
     *
     * @returns {Promise<AgentOutput>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async submit(agentId: string, payload: AgentInput): Promise<AgentOutput> {
        const url = this.parser.url('/backend/agent/$agent_id<[0-9]+|^~>/message', {
            'agent_id': agentId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as AgentOutput;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
